import React from 'react';
import _ from 'lodash';
import { Chip, Spinner, Tooltip } from 'design-system';
import { useObjectPreview } from 'corp/hooks/smartId/useObjectPreview';
import { INamedObjectTypes, IProjectSLAGroupPreviewJson } from '@scale/shared/types/lookup';
import IsomorphicLink from 'corp/components/UI/IsomorphicLink';
import moment from 'moment';
import {
  BusinessUnitMappingName,
  BusinessUnitProductMappingName,
  StatusMapping,
} from '@scale/shared/dailyPlan/dailyPlanProjectGroup';
const ProjectSLAGroupPreview: React.FC<{ id: string }> = ({ id }) => {
  const {
    value: projectSLAGroup,
    loading,
    error,
  } = useObjectPreview<IProjectSLAGroupPreviewJson>(id, INamedObjectTypes.ProjectSLAGroup);
  if (error) return <span>Sorry, there was an error</span>;
  if (loading) return <Spinner />;

  return (
    <div className="project-preview">
      <style jsx>{`
        .project-preview__banner {
          font-weight: bold;
          padding: 10px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content: flex-start;
        }

        .project-preview__thing-list > div {
          display: flex;
        }

        .project-preview__thing-list strong {
          color: #666;
          margin-right: 10px;
          min-width: 120px;
          text-align: right;
        }
      `}</style>
      <div className="project-preview__banner">
        <Chip
          label={_.get(
            StatusMapping,
            projectSLAGroup?.status || '',
            _.startCase(projectSLAGroup?.status),
          )}
        />
        <h3 style={{ margin: '0 5px' }}>{projectSLAGroup?.name}</h3>
      </div>
      <div className="project-preview__body">
        <div className="project-preview__thing-list">
          <div>
            <strong>Project SLA Group</strong>
            <IsomorphicLink target="_blank" rel="noopener noreferrer" href={`/project_group/${id}`}>
              {id}{' '}
            </IsomorphicLink>
          </div>
          {projectSLAGroup?.businessUnitProduct && (
            <div>
              <strong>Business Unit Product</strong>
              {_.get(
                BusinessUnitProductMappingName,
                projectSLAGroup?.businessUnitProduct,
                _.startCase(projectSLAGroup?.businessUnitProduct),
              )}{' '}
            </div>
          )}
          {projectSLAGroup?.slaCadence && (
            <div>
              <strong>SLA Cadence</strong>
              {_.startCase(projectSLAGroup?.slaCadence)}{' '}
            </div>
          )}

          {projectSLAGroup?.businessUnit && (
            <div>
              <strong>Business Unit</strong>
              {_.get(
                BusinessUnitMappingName,
                projectSLAGroup?.businessUnit,
                _.startCase(projectSLAGroup?.businessUnit),
              )}{' '}
            </div>
          )}

          {projectSLAGroup?.fulfillmentMechanism && (
            <div>
              <strong>Fulfillment Mechanism</strong>
              {_.startCase(projectSLAGroup?.fulfillmentMechanism)}{' '}
            </div>
          )}

          {projectSLAGroup && !!projectSLAGroup.createdAt && (
            <div>
              <strong>Created</strong>
              <Tooltip
                placement={'top'}
                title={new Date(projectSLAGroup.createdAt).toLocaleString()}
              >
                <span>{moment(projectSLAGroup.createdAt).fromNow()}</span>
              </Tooltip>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectSLAGroupPreview;
